import MirrorCreateModal from "./MirrorCreateModal";

const MirrorEditModal = () => <MirrorCreateModal isEdit />;

export default MirrorEditModal;
